export const ALERT_EVENTS = [
  'aluno_inativo',
  'matricula_expirando',
  'curso_concluido_aprovado',
  'curso_concluido_reprovado',
  'curso_concluido_certificado',
]

const DEFAULT_ALERTS_MATRIX = {
  aluno_inativo: { active: true, firstReminderHours: 168, repeatEveryHours: 168, maxSends: 3 },
  matricula_expirando: { active: true, firstReminderHours: 120, repeatEveryHours: 0, maxSends: 1 },
  curso_concluido_aprovado: { active: true, firstReminderHours: 1, repeatEveryHours: 0, maxSends: 1 },
  curso_concluido_reprovado: { active: true, firstReminderHours: 1, repeatEveryHours: 0, maxSends: 1 },
  // Certificate delivery already has an immediate trigger on issuance,
  // so scheduled alert routines must start disabled to avoid replays.
  curso_concluido_certificado: { active: false, firstReminderHours: 1, repeatEveryHours: 0, maxSends: 1 },
}

export const buildDefaultAlertsMatrix = () => (
  Object.fromEntries(
    Object.entries(DEFAULT_ALERTS_MATRIX).map(([eventKey, config]) => [eventKey, { ...config }])
  )
)
